/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Magnet } from '../models/magnet';
import { MagnetDocumentList } from '../models/magnet-document-list';
import { magnetGetDocumentList } from '../fn/magnet/magnet-get-document-list';
import { MagnetGetDocumentList$Params } from '../fn/magnet/magnet-get-document-list';
import { magnetGetMagnet } from '../fn/magnet/magnet-get-magnet';
import { MagnetGetMagnet$Params } from '../fn/magnet/magnet-get-magnet';
import { magnetGetTagList } from '../fn/magnet/magnet-get-tag-list';
import { MagnetGetTagList$Params } from '../fn/magnet/magnet-get-tag-list';
import { TagSection } from '../models/tag-section';

@Injectable({ providedIn: 'root' })
export class MagnetService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `magnetGetMagnet()` */
  static readonly MagnetGetMagnetPath = '/magnet/{magnetId}';

  /**
   * Get magnet.
   *
   * Get magnet
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `magnetGetMagnet()` instead.
   *
   * This method doesn't expect any request body.
   */
  magnetGetMagnet$Response(params: MagnetGetMagnet$Params, context?: HttpContext): Observable<StrictHttpResponse<Magnet>> {
    const obs = magnetGetMagnet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get magnet.
   *
   * Get magnet
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `magnetGetMagnet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  magnetGetMagnet(params: MagnetGetMagnet$Params, context?: HttpContext): Observable<Magnet> {
    const resp = this.magnetGetMagnet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Magnet>): Magnet => r.body)
    );
  }

  /** Path part for operation `magnetGetDocumentList()` */
  static readonly MagnetGetDocumentListPath = '/magnet/{magnetId}/document/list';

  /**
   * Search documents of the magnet.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `magnetGetDocumentList()` instead.
   *
   * This method doesn't expect any request body.
   */
  magnetGetDocumentList$Response(params: MagnetGetDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<MagnetDocumentList>> {
    const obs = magnetGetDocumentList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Search documents of the magnet.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `magnetGetDocumentList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  magnetGetDocumentList(params: MagnetGetDocumentList$Params, context?: HttpContext): Observable<MagnetDocumentList> {
    const resp = this.magnetGetDocumentList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MagnetDocumentList>): MagnetDocumentList => r.body)
    );
  }

  /** Path part for operation `magnetGetTagList()` */
  static readonly MagnetGetTagListPath = '/magnet/{magnetId}/tag/list';

  /**
   * Get all tags of the magnet.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `magnetGetTagList()` instead.
   *
   * This method doesn't expect any request body.
   */
  magnetGetTagList$Response(params: MagnetGetTagList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagSection>>> {
    const obs = magnetGetTagList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all tags of the magnet.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `magnetGetTagList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  magnetGetTagList(params: MagnetGetTagList$Params, context?: HttpContext): Observable<Array<TagSection>> {
    const resp = this.magnetGetTagList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<TagSection>>): Array<TagSection> => r.body)
    );
  }

}
